export default "<style>\n</style>\n\n<inspector--element></inspector--element>";